import React from 'react';
import { Helmet } from 'react-helmet';
import { withCustomContexts } from '../../../shared/components/Contexts';
import { DiLayout, DiNotFoundPage, LmHeader } from '../../../shared/components/DiLayout';
import { createSchedulingSessionStateLandingPage } from '../../../shared/components/SchedulingSessionState';
import { ITrackerData } from '../../../types';
import OfficeListMapV2 from '../../components/OfficeListMapV2';
import WidgetSessionOpenedMutation from '../../components/WidgetSessionOpenedMutation';
import { Group } from './types';

interface GroupPageV2Props {
  group: Group | null;
  trackerData: ITrackerData;
}

function GroupPageV2({ group, trackerData }: GroupPageV2Props) {
  if (!group) return <DiNotFoundPage />;
  return (
    <DiLayout header={<LmHeader group={group} />} size="xxl">
      <Helmet>
        <title>{group.name}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <WidgetSessionOpenedMutation widgetId={trackerData.widgetId} />
      <OfficeListMapV2 offices={group.offices.nodes} groupId={group.id} />
    </DiLayout>
  );
}

export default createSchedulingSessionStateLandingPage(withCustomContexts(GroupPageV2));
